<template>
    <Dialog v-model:visible="isVisible"  modal header="Choose Your Credits" :style="{ width: '800px' }">
      <div class="credit-header" v-if="dialogCreditMessage" >
        <Message severity="info" size="large">{{ dialogCreditMessage }}</Message>
      </div>
      <div class="credit-cards">
        <div v-for="(card, index) in getProducts" :key="index" :class="['credit-card', card.label.toLowerCase()]">
          <div class="card-header">
            <span>{{ card.label }}</span>
          </div>
          <div class="card-content">
            <h2>{{ card.golds }} {{ $t('credits.tokens') }}</h2>
            <p>${{ (card.price / card.golds).toFixed(2) }} {{ $t('credits.per_token') }}</p>
          </div>
          <div class="card-bonus">
            <span>+{{ card.gift_golds }} {{ $t('credits.bonus') }}</span>
          </div>
          <div class="card-price">
            <h3>${{ card.price }}*</h3>
            <Button :label="$t('credits.buy')" class="p-button-rounded" severity="contrast" outlined @click="buyProduct(card)"></Button>
          </div>
        </div>
      </div>
    </Dialog>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    name: 'LoadCredit',
    props: ['my_profile', 'products', 'dialogCreditMessage'],
    data() {
      return {
        isVisible: false,
      };
    },
    computed: {
      getProducts() {
        return this.products.filter(product => product.product_type === 1);
      }
    },
    methods: {
        toggle () {
            this.isVisible = !this.isVisible;
        },
        show () {
            this.isVisible = true;
        },
        async buyProduct(card) {
          try {
                const response = await axios.get(this.$socket_url + '/stripe/createLinkForProduct/' + card.gateway_product_id, {
                    headers: {
                        'Authorization': this.$socket.authKeyUnique.auth,
                    }
                });

                if (response.data.url) {
                    this.isVisible = false;
                    window.open(response.data.url, '_blank').focus();
                }
                console.log(response.data)
            } catch (error) {
                console.log(error);
            }
        }
    }
  };
  </script>
  
  <style scoped>
  .credit-cards {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }
  
  .credit-card {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    padding: 1rem;
    text-align: center;
    width: 33.3%;
  }
  
  .credit-card .card-header span {
        color: #fff;
        padding: 2px 7px;
        font-family: Montserrat, "Helvetica Neue", Helvetica, Arial, sans-seri;
        font-size: 0.6875rem;
        font-weight: 600;
        line-height: 0.9375rem;
        letter-spacing: 0.0125rem;
        border: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 12px;
        text-transform: uppercase;
  }
  
  .credit-card.elite {
    background: linear-gradient(to left, rgb(255, 78, 129), rgb(255, 148, 148));
  }
  
  .credit-card.classic {
    background: linear-gradient(to left, rgb(87, 87, 255), rgb(171, 171, 255));
  }
  
  .credit-card.basic {
    background: linear-gradient(to right, rgb(157, 213, 255), rgb(36, 160, 255));
  }
  
  .card-content h2 {
    margin-top: 1rem;
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
    margin-bottom: 0;
    color: #fff;
    text-align: left;
  }
  .card-content p {
    text-align: left;
    margin-top: 0;
    color: #fff;
    width: 100%;
  }

  .card-bonus {
    width: 80%;
    margin: 0;
    background-color: #fff;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    margin-left: -1rem;
    color: #000;
  }

  .card-price h3 {
    margin: 1rem 0;

    color: #fff;
  }
  
  .card-bonus span {
    background: #ffffff90;
    padding: 0.3rem 0.7rem;
    border-radius: 10px;
    display: inline-block;
  }
  
  .p-button-rounded {
    margin-top: 1rem;
    width: 80%;
  }
  .credit-header {
    text-align: center;
    margin: 20px;
}

  </style>